var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 516.4829396325459 514.6745406824147",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l516.4829 0l0 514.67456l-516.4829 0l0 -514.67456z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l516.4829 0l0 514.67456l-516.4829 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m15.249344 257.33728l0 0c0 -134.20087 108.79128 -242.99214 242.99211 -242.99214l0 0c64.445526 0 126.251526 25.600882 171.82138 71.170746c45.569885 45.569862 71.170746 107.37586 71.170746 171.82138l0 0c0 134.20084 -108.79126 242.99213 -242.99213 242.99213l0 0c-134.20084 0 -242.99211 -108.79129 -242.99211 -242.99213z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m15.249344 257.33728l0 0c0 -134.20087 108.79128 -242.99214 242.99211 -242.99214l0 0c64.445526 0 126.251526 25.600882 171.82138 71.170746c45.569885 45.569862 71.170746 107.37586 71.170746 171.82138l0 0c0 134.20084 -108.79126 242.99213 -242.99213 242.99213l0 0c-134.20084 0 -242.99211 -108.79129 -242.99211 -242.99213z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m165.04144 401.33728l0 -324.0l82.0 0q42.40625 0 66.0 10.609375q23.59375 10.59375 33.1875 33.203125q9.609375 22.593742 9.609375 58.593742l0 117.593765q0 36.40625 -9.609375 59.40625q-9.59375 23.0 -33.0 33.796875q-23.390625 10.796875 -65.390625 10.796875l-82.796875 0zm71.59375 -49.59375l11.203125 0q16.40625 0 23.59375 -4.796875q7.203125 -4.8125 9.0 -14.40625q1.8125 -9.609375 1.8125 -24.0l0 -141.20314q0 -14.40625 -2.203125 -23.203125q-2.203125 -8.796875 -9.40625 -12.796875q-7.1875 -3.9999924 -23.1875 -3.9999924l-10.8125 0l0 224.40625z",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerIcon);
export default __webpack_public_path__ + "static/media/dealer-icon.b8552ef36ccd33f83252c902b4fd2e7b.svg";
export { ForwardRef as ReactComponent };